export default __webpack_public_path__ + "0269944c.jpg";